<template>
    <ul class="navbar-nav sidebar slim-scroll scroll-y" v-dragscroll="!isMobile()">
        <li class="text-uppercase font-weight-bold py-4 px-5">
            Main Navigation
        </li>
        <router-link v-bind:to="{ name: 'index' }" v-bind:tag="'li'" class="nav-item">
            <a class="nav-link">
                <img src="/static/images/icon/dashboard.svg" /> Dashboard
            </a>
        </router-link>
        <router-link v-bind:to="{ name: 'profil/employee/index' }" v-bind:tag="'li'" class="nav-item" v-if="(profile.isEmployee && (profile.employee.isDirector || profile.employee.isManager || profile.employee.isMentor || profile.employee.isBranchStaff || profile.employee.isCoordinator || profile.employee.isTeacher || profile.employee.isBranchHead))">
            <a class="nav-link">
                <img src="/static/images/icon/staff.svg" /> Data Diri
            </a>
        </router-link>
        <router-link v-bind:to="{ name: 'student/index' }" v-bind:tag="'li'" class="nav-item" v-if="profile.isAdmin || (profile.isEmployee && (profile.employee.isBranchStaff || profile.employee.isDirector || profile.employee.isManager || profile.employee.isBranchHead))">
            <a class="nav-link">
                <img src="/static/images/icon/student.svg" /> Siswa
            </a>
        </router-link>
        <router-link v-bind:to="{ name: 'employee/index' }" v-bind:tag="'li'" class="nav-item" v-if="profile.isAdmin || (profile.isEmployee && (profile.employee.isBranchStaff || profile.employee.isDirector || profile.employee.isManager || profile.employee.isCoordinator || profile.employee.isBranchHead))">
            <a class="nav-link">
                <img src="/static/images/icon/staff.svg" /> Pegawai BTA
            </a>
        </router-link>
        <router-link v-bind:to="{ name: 'banner/index' }" v-bind:tag="'li'" class="nav-item" v-if="profile.isAdmin">
            <a class="nav-link">
                <img src="/static/images/icon/banner.svg" /> Banner
            </a>
        </router-link>
        <router-link v-bind:to="'#'" v-bind:tag="'li'" class="nav-item" v-if="false">
            <a class="nav-link">
                <img src="/static/images/icon/announcement.svg" /> Pengumuman
            </a>
        </router-link>
        <router-link v-bind:to="{ name: 'article/index' }" v-bind:tag="'li'" class="nav-item" v-if="profile.isAdmin">
            <a class="nav-link">
                <img src="/static/images/icon/news.svg" /> Berita
            </a>
        </router-link>
        <router-link v-bind:to="{ name: 'branch/index' }" v-bind:tag="'li'" class="nav-item" v-bind:class="!profile.isAdmin && !(profile.isEmployee && (profile.employee.isBranchStaff || profile.employee.isDirector || profile.employee.isManager || profile.employee.isBranchHead)) && this.$route.path.match(/^\/student/) ? 'active' : ''" v-if="profile.isAdmin || profile.isEmployee">
            <a class="nav-link">
                <img src="/static/images/icon/branch.svg" /> Cabang
            </a>
        </router-link>
        <router-link v-bind:to="{ name: 'product/index' }" v-bind:tag="'li'" class="nav-item" v-if="profile.isAdmin">
            <a class="nav-link">
                <img src="/static/images/icon/product.svg" /> Product
            </a>
        </router-link>
        <li class="nav-item" v-bind:class="this.$route.path.match(/^\/tryout/) ? 'active' : ''" v-if="profile.isAdmin || (profile.isEmployee && (profile.employee.isDirector || profile.employee.isManager || profile.employee.isTeacher || profile.employee.isBranchStaff || profile.employee.isBranchHead || profile.employee.isMentor))">
            <a href="/tryout" class="nav-link" v-on:click.prevent.stop="showSubmenu">
                <img src="/static/images/icon/tryout.svg" /> Tryout
                <i class="fa fa-chevron-down"></i>
            </a>
            <ul class="navbar-nav">
                <router-link v-if="profile.isAdmin || (profile.isEmployee && (profile.employee.isDirector || profile.employee.isManager || profile.employee.isTeacher))" v-bind:to="{ name: 'tryout/offline/index' }" v-bind:tag="'li'" class="nav-item" v-on:click.native="hideSubmenus()">
                    <a class="nav-link">
                        Offline
                    </a>
                </router-link>
                <router-link v-if="profile.isAdmin || (profile.isEmployee && (profile.employee.isDirector || profile.employee.isManager || profile.employee.isTeacher))" v-bind:to="{ name: 'tryout/online/index' }" v-bind:tag="'li'" class="nav-item" v-on:click.native="hideSubmenus()">
                    <a class="nav-link">
                        Online
                    </a>
                </router-link>
                <router-link v-if="profile.isAdmin || (profile.isEmployee && (profile.employee.isBranchStaff || profile.employee.isMentor || profile.employee.isBranchHead))" v-bind:to="{ name: 'tryout/monitoring/index' }" v-bind:tag="'li'" class="nav-item" v-on:click.native="hideSubmenus()">
                    <a class="nav-link">
                        Monitoring
                    </a>
                </router-link>
                <router-link v-if="profile.isAdmin || (profile.isEmployee && (profile.employee.isBranchStaff || profile.employee.isBranchHead))" v-bind:to="{ name: 'tryout/recap/index' }" v-bind:tag="'li'" class="nav-item" v-on:click.native="hideSubmenus()">
                    <a class="nav-link">
                        Recap
                    </a>
                </router-link>
            </ul>
        </li>
        <router-link v-bind:to="'#'" v-bind:tag="'li'" class="nav-item" v-if="false">
            <a class="nav-link">
                <img src="/static/images/icon/psikotest.svg" /> Psikotest
            </a>
        </router-link>
        <router-link v-bind:to="{name: 'material/index'}" v-bind:tag="'li'" class="nav-item">
            <a class="nav-link">
                <img src="/static/images/icon/curriculum.svg" /> Bahan Ajar
            </a>
        </router-link>
        <router-link v-bind:to="{name: 'schedule/index'}" v-bind:tag="'li'" class="nav-item" v-if="profile.isAdmin || (profile.isEmployee && (profile.employee.isDirector || profile.employee.isManager || profile.employee.isMentor || profile.employee.isBranchStaff || profile.employee.isCoordinator || profile.employee.isTeacher || profile.employee.isBranchHead))">
            <a class="nav-link">
                <img src="/static/images/icon/schedule.svg" /> Jadwal
            </a>
        </router-link>
        <router-link v-bind:to="{name: 'evaluation/index'}" v-bind:tag="'li'" class="nav-item" v-if="profile.isAdmin || (profile.isEmployee && (profile.employee.isDirector || profile.employee.isManager || profile.employee.isMentor || profile.employee.isBranchStaff || profile.employee.isTeacher || profile.employee.isCoordinator || profile.employee.isBranchHead))">
            <a class="nav-link">
                <img src="/static/images/icon/report.svg" /> Laporan Pengajaran
            </a>
        </router-link>
        <router-link v-bind:to="{name: 'forum/index'}" v-bind:tag="'li'" class="nav-item">
            <a class="nav-link">
                <i class="fa fa-comments-o fa-lg"></i> Forum
            </a>
        </router-link>
        <li class="nav-item" v-bind:class="this.$route.path.match(/^\/program-study/) ? 'active' : ''" v-if="profile.isAdmin || (profile.isEmployee && (profile.employee.isMentor || profile.employee.isBranchStaff || profile.employee.isBranchHead))">
            <a href="/program-study" class="nav-link" v-on:click.prevent.stop="showSubmenu">
                <img src="/static/images/icon/program-study.svg" /> Prodi Kuliah
                <i class="fa fa-chevron-down"></i>
            </a>
            <ul class="navbar-nav">
                <router-link v-bind:to="{ name: 'program-study/index', params: {type: courseCategory.id} }" v-bind:tag="'li'" class="nav-item" v-on:click.native="hideSubmenus()" v-for="courseCategory in courseCategories" v-bind:key="courseCategory.id">
                    <a class="nav-link">
                        {{ courseCategory.name }}
                    </a>
                </router-link>
								<router-link v-bind:to="{ name: 'program-study/rekap-snbt' }" v-bind:tag="'li'" class="nav-item" v-on:click.native="hideSubmenus()">
                    <a class="nav-link">
                        REKAP SNBT
                    </a>
                </router-link>
            </ul>
        </li>
        <router-link v-bind:to="{ name: 'employee/password' }" v-bind:tag="'li'" class="nav-item">
            <a class="nav-link">
                <img src="/static/images/icon/psikotest.svg" /> Ganti Password
            </a>
        </router-link>
    </ul>
</ul>
</template>

<script>
    import { mapState } from 'vuex';
    import { dragscroll } from 'vue-dragscroll';

    export default {
        name: "Sidebar",
        directives: {dragscroll},
        computed: mapState([
            'profile'
        ]),
        data() {
            return {
                courseCategories: []
            };
        },
        methods: {
            showSubmenu($event) {
                var currentClassMenu = $event.target.closest('.nav-item').classList;
                var hasOpened = currentClassMenu.contains('open');
                this.hideSubmenus();
                if (!hasOpened) {
                    currentClassMenu.add('open');
                }
            },
            hideSubmenus() {
                var openedMenus = document.getElementsByClassName("nav-item open");
                for (var i = 0; i < openedMenus.length; i++) {
                    openedMenus[i].classList.remove('open');
                }
            },
            isMobile() {
                return 'ontouchstart' in window || navigator.msMaxTouchPoints;
            }
        },
        created() {
            this.axios.get(process.env.API_URL + '/course-category').then(response => {
                this.courseCategories = response.data.data;
            });
        }
    };
</script>

<style scoped>
    @media (min-width: 992px){
        ul.navbar-nav.sidebar.slim-scroll::-webkit-scrollbar{ width: 0px; height: 0px; }
        ul.navbar-nav.sidebar{
            position: fixed;
            top: 113px;
            left: 0;
            bottom: 0;
            -webkit-flex-direction: column;
            -ms-flex-direction: column;
            flex-direction: column;
            background-color: #C10F27;
            width: 270px;
        }
        ul.navbar-nav.sidebar > li.nav-item a + ul > li a {
            padding-left: 5rem;
        }
        ul.navbar-nav.sidebar > li.nav-item.open .fa-chevron-down {
            transform: rotate(-90deg);
        }
    }
    @media (max-width: 991.98px) { 
        ul.navbar-nav.sidebar > li.nav-item a + ul > li {
            padding-left: 2.5rem;
        }
        ul.navbar-nav.sidebar > li.nav-item:not(.open) .fa-chevron-down {
            transform: rotate(-90deg);
        }
    }
    ul.navbar-nav.sidebar li {
        font-size: 0.9rem;
        letter-spacing: 0.04rem;
        color: #fff;
        font-family: Ubuntu-Regular;
        position: relative;
    }
    ul.navbar-nav.sidebar li a {
        padding: 1rem 2.4rem;
        color: #fff;
    }

    ul.navbar-nav.sidebar > li.nav-item a + ul {
        display: none;
    }
    ul.navbar-nav.sidebar > li.nav-item.open a + ul {
        display: initial;
        background: #C10F27;
    }
    ul.navbar-nav.sidebar > li.nav-item.open a + ul > li:not(.active) {
        background: transparent;
    }
    ul.navbar-nav.sidebar > li.nav-item .fa-chevron-down {
        float: right;
        padding-top: 0.25rem;
        -webkit-transition: all 0.2s ease;
        -moz-transition: all 0.2s ease;
        -o-transition: all 0.2s ease;
        transition: all 0.2s ease;
    }

    ul.navbar-nav.sidebar > li.nav-item.active > a,
    ul.navbar-nav.sidebar > li.nav-item.active > a + ul > li.active > a{
        font-family: Ubuntu-Bold;
    }
    ul.navbar-nav li.nav-item:active,
    ul.navbar-nav li.nav-item:hover,
    ul.navbar-nav li.nav-item.open {
        background: #d31027;
        background: rgba(211, 16, 39, 0.7);
        background: linear-gradient(to right, rgba(211, 16, 39, 0.7), rgba(234, 56, 77, 0.7));
        -webkit-transition: all 0.2s linear;
        -moz-transition: all 0.2s linear;
        -o-transition: all 0.2s linear;
        transition: all 0.2s linear;
    }
    ul.navbar-nav > li.nav-item.active{
        background: #d31027;
        background: linear-gradient(to right, #d31027, #ea384d);
    }
    ul.navbar-nav.sidebar > li.nav-item a img,
    ul.navbar-nav.sidebar > li.nav-item a i.fa {
        width: 19px;
        margin-right: 1rem;
    }
    ul.navbar-nav.sidebar li a.nav-link:after {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/layouts/Sidebar.vue